import { IdentifiedIssue, CategorizedIssues } from './pending-issues.model';

export function categorizeIssues(pendingIssues: IdentifiedIssue[]): CategorizedIssues {
  return {
    expired: pendingIssues.filter(issue => {
      return issue?.status?.value?.toString().toLowerCase() === 'expired';
    }),
    unknown: pendingIssues.filter(issue => {
      return issue?.status?.value?.toString().toLowerCase() !== 'expired';
    }),
  };
}
